import React from 'react';
import { StethoscopeIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-white/10 bg-[#040C22] px-4 pb-32 pt-12 text-white/60 sm:pb-28" data-id="element-188" data-mp="207t1q85t1jl1">
      <div className="mx-auto max-w-4xl text-center" data-id="element-189" data-mp="2f5d5jbqyt8pm">
        <p className="flex items-center justify-center gap-2 font-display text-lg font-black uppercase tracking-wide text-white" data-id="element-190" data-mp="2f41z1464xmut">
          <StethoscopeIcon className="h-5 w-5 text-aqua" aria-hidden="true" data-id="element-191" data-mp="1mfwgmo2k09y5" />
          ABG Clinical Roadmap™
        </p>
        <p className="mt-1 text-sm" data-id="element-192" data-mp="1hhulv5vrmm6u">Created by Rachel Bennett</p>
        <p className="mx-auto mt-4 max-w-2xl text-sm leading-relaxed" data-id="element-193" data-mp="1hf8hff468msu">
          A digital educational reference collection for studying arterial blood gases, acid-base physiology, compensation
          concepts, and interpretation principles.
        </p>
        <p className="mt-8 text-left text-xs leading-relaxed text-white/45 sm:text-center" data-id="element-194" data-mp="13odcgdwsmpuj">
          <strong className="text-white/70" data-id="element-195" data-mp="ypscmflge86m">EDUCATIONAL DISCLAIMER:</strong> This product is intended for educational and
          professional reference purposes only. It does not provide patient-specific medical advice, diagnose medical conditions,
          establish validated clinical decision algorithms, or replace professional judgment, current evidence, supervised
          clinical training, institutional protocols, or applicable professional guidelines. Laboratory findings must be
          interpreted in the appropriate clinical context by qualified professionals.
        </p>
        <p className="mt-4 text-xs text-white/45" data-id="element-196" data-mp="zlupm9ltgs0z">
          Illustrative reference values are offer-positioning estimates, not verified retail prices.
        </p>
        <p className="mt-6 text-xs text-white/40" data-id="element-197" data-mp="19izckbnhkriu">© 2026 · All rights reserved.</p>
      </div>
    </footer>;
}